import React from "react";
import { Stack } from "@mui/material";
import TabLayout from "../../helpers/TabLayout";
import { sessionUpdateLongDescription } from "../../../api/session";
import { useRouteLoaderData } from "react-router-dom";
import useInfoSnackbar from "../../../hooks/useInfoSnackbar";
import EditButtons from "../helpers/EditButtons";
import BioDisplay from "./BioDisplay";
import useEditObject from "../../../hooks/useEditObject";
import EditableField from "../helpers/EditableField";

const BioTab = () => {
  const loaderData = useRouteLoaderData("profileComponent");
  const longDescription = loaderData.longDescriptionRes?.data;
  const {
    editObject,
    isEditable,
    startEdit,
    stopEdit,
    editHandler: handleFieldChange,
  } = useEditObject();

  const infoSnackbar = useInfoSnackbar();

  const handleBioUpdate = async () => {
    const longDescription = editObject.current.longDescription;
    const response = await sessionUpdateLongDescription(longDescription);
    if (response.code === "SUCCESS") {
      loaderData.longDescriptionRes.data = longDescription;
      infoSnackbar.alertSuccess("Bio updated successfully.");
    } else {
      infoSnackbar.alertError(response.message);
    }
    stopEdit();
  };

  const placeholder = "Tell us about yourself...";

  return (
    <TabLayout
      headerLabel="Bio"
      skeletonLines={15}
    >
      <Stack
        height="100%"
        width="100%"
        alignItems="center"
        justifyContent="space-between"
      >
        {isEditable ? (
          <EditableField
            type="text"
            id="longDescription"
            name="longDescription"
            initialValue={longDescription}
            isEditable
            onChange={handleFieldChange}
            placeholder={placeholder}
            margin="normal"
            multiline={true}
            rows={13}
            variant="outlined"
          />
        ) : (
          <BioDisplay
            longDescription={longDescription}
            placeHolder={placeholder}
          />
        )}
        <EditButtons
          isEditable={isEditable}
          onUpdateClicked={startEdit}
          onSaveClicked={handleBioUpdate}
          onCancelClicked={stopEdit}
        />
      </Stack>
    </TabLayout>
  );
};

export default BioTab;